import{a as i}from"./chunk-EI7MMDWY.js";var e=i(n=>JSON.parse(JSON.stringify(n,(r,t)=>typeof t=="bigint"?Number(t):t)),"JsonFixBigInt");export{e as a};
